import _ from 'underscore'

export const LOCAL_STORAGE_REDUX_STATE_KEY = 'SERIAL_TICKETS_STATE'

export default function getPreloadedState() {
  if (
    window.location.search.includes('backendError=paymentRejected') ||
    window.location.search.includes('backendError=paymentCancelled')
  ) {
    const preloadedState = extractReduxStateFromLocalStorage()
    removeReduxStateFromLocalStorage()
    return preloadedState
  }

  return {}
}

export function extractReduxStateFromLocalStorage() {
  try {
    const stringifiedReduxState = window.localStorage.getItem(LOCAL_STORAGE_REDUX_STATE_KEY)
    const parsedReduxState = JSON.parse(stringifiedReduxState)
    if (!_.isObject(parsedReduxState) || _.isArray(parsedReduxState) || _.isFunction(parsedReduxState)) {
      throw Error('State is not a plain object')
    }
    return parsedReduxState
  } catch (error) {
    return {}
  }
}

export function removeReduxStateFromLocalStorage() {
  window.localStorage.removeItem(LOCAL_STORAGE_REDUX_STATE_KEY)
}

export function addReduxStateToLocalStorage(reduxState) {
  window.localStorage.setItem(LOCAL_STORAGE_REDUX_STATE_KEY, JSON.stringify(reduxState))
}
